export default "__VITE_ASSET__DbNoG645__"